<template>
  <div>
    <!-- 基金信息 -->
    <div class="desp-items-group" v-if="detail.fundInfoList.length > 0">
      <div class="desp-items-group-title"></div>
      <div class="desp-items-group-header">
        <div class="title">Business Information of the Proposed Funds</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <div class="shareholder-files">
            <div class="shareholder-file-wrapper" v-for="(item, idx) in detail.fundInfoList" :key="idx">
              <template
                v-if="
                  item.fundBusinessLicenseUrls &&
                  item.fundBusinessLicenseUrls.length > 0 &&
                  item.fundInfoUrls &&
                  item.fundInfoUrls.length > 0 &&
                  item.fundMemoUrls &&
                  item.fundMemoUrls.length > 0
                "
              >
                <div class="member-info">
                  <span class="name">{{ item.fundName }}</span>
                  <span class="held">{{ item.fundType }}</span>
                </div>
                <div class="file-urls">
                  <company-file-list :fileUrls="item.fundBusinessLicenseUrls.concat(item.fundMemoUrls.concat(item.fundInfoUrls))" :detail="detail" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 基金的 -->
    <div class="desp-items-group" v-if="fundIcMerge.length > 0">
      <div class="desp-items-group-title"></div>
      <div class="desp-items-group-header">
        <div class="title">Passport / IC of Individual Shareholder(s) and Director(s) of the Fund(s)</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <div class="shareholder-files">
            <div class="shareholder-file-wrapper" v-for="(item, idx) in fundIcMerge" :key="idx">
              <template v-if="item.fileUrls && item.fileUrls.length > 0">
                <div class="member-info">
                  <span class="name">{{ item.fullName }}</span>
                  <span class="held">{{ positionHeldFormat(item.positionHeld) }}</span>
                </div>
                <div class="file-urls">
                  <company-file-list :fileUrls="item.fileUrls" :detail="detail" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="desp-items-group" v-if="companyFundMemberFiles && companyFundMemberFiles.addressFiles">
      <div class="desp-items-group-title"></div>
      <div class="desp-items-group-header">
        <div class="title">Proof of Resident/Company Address of the Fund(s) – Scanned Copy</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <div class="shareholder-files">
            <div class="shareholder-file-wrapper" v-for="(item, idx) in companyFundMemberFiles.addressFiles" :key="idx">
              <template v-if="item.fileUrls && item.fileUrls.length > 0">
                <div class="member-info">
                  <span class="name">{{ item.fullName }}</span>
                  <span class="held">{{ positionHeldFormat(item.positionHeld) }}</span>
                </div>
                <div class="file-urls">
                  <company-file-list :fileUrls="item.fileUrls" :detail="detail" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="desp-items-group" v-if="companyFundMemberFiles && companyFundMemberFiles.businessLicenseFiles">
      <div class="desp-items-group-title"></div>
      <div class="desp-items-group-header">
        <div class="title">Corporate Shareholder's Business Certificate & Articles of Association of the Fund(s) – Scanned Copy</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <div class="shareholder-files">
            <div class="shareholder-file-wrapper" v-for="(item, idx) in companyFundMemberFiles.businessLicenseFiles" :key="idx">
              <template v-if="item.fileUrls && item.fileUrls.length > 0">
                <div class="member-info">
                  <span class="name">{{ item.fullName }}</span>
                  <span class="held">{{ positionHeldFormat(item.positionHeld) }}</span>
                </div>
                <div class="file-urls">
                  <company-file-list :fileUrls="item.fileUrls" :detail="detail" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 基金的股权架构图 -->
    <div class="desp-items-group" v-if="detail.fundsShareholdingStructureUrls && detail.fundsShareholdingStructureUrls.length > 0">
      <div class="desp-items-group-header">
        <div class="title">Shareholder Structure of the Proposed Fund(s)</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <company-file-list :fileUrls="detail.fundsShareholdingStructureUrls" :detail="detail" />
        </div>
      </div>
    </div>

    <!-- 基金管理公司的 -->
    <div class="desp-items-group" v-if="passportIcMerge.length > 0">
      <div class="desp-items-group-title"></div>
      <div class="desp-items-group-header">
        <div class="title">Passport / IC of Individual Shareholder(s) and Director(s) of the Fund Manager</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <div class="shareholder-files">
            <div class="shareholder-file-wrapper" v-for="(item, idx) in passportIcMerge" :key="idx">
              <template v-if="item.fileUrls && item.fileUrls.length > 0">
                <div class="member-info">
                  <span class="name">{{ item.fullName }}</span>
                  <span class="held">{{ positionHeldFormat(item.positionHeld) }}</span>
                </div>
                <div class="file-urls">
                  <company-file-list :fileUrls="item.fileUrls" :detail="detail" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="desp-items-group" v-if="companyMemberFiles && companyMemberFiles.addressFiles">
      <div class="desp-items-group-title"></div>
      <div class="desp-items-group-header">
        <div class="title">Proof of Resident/Company Address of the Fund Manager – Scanned Copy</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <div class="shareholder-files">
            <div class="shareholder-file-wrapper" v-for="(item, idx) in companyMemberFiles.addressFiles" :key="idx">
              <template v-if="item.fileUrls && item.fileUrls.length > 0">
                <div class="member-info">
                  <span class="name">{{ item.fullName }}</span>
                  <span class="held">{{ positionHeldFormat(item.positionHeld) }}</span>
                </div>
                <div class="file-urls">
                  <company-file-list :fileUrls="item.fileUrls" :detail="detail" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="desp-items-group" v-if="companyMemberFiles && companyMemberFiles.businessLicenseFiles">
      <div class="desp-items-group-title"></div>
      <div class="desp-items-group-header">
        <div class="title">Corporate Shareholder's Business Certificate & Articles of Association of the Fund Manager – Scanned Copy</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <div class="shareholder-files">
            <div class="shareholder-file-wrapper" v-for="(item, idx) in companyMemberFiles.businessLicenseFiles" :key="idx">
              <template v-if="item.fileUrls && item.fileUrls.length > 0">
                <div class="member-info">
                  <span class="name">{{ item.fullName }}</span>
                  <span class="held">{{ positionHeldFormat(item.positionHeld) }}</span>
                </div>
                <div class="file-urls">
                  <company-file-list :fileUrls="item.fileUrls" :detail="detail" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="desp-items-group" v-if="detail.transferBusinessProfileAndArticleUrls && detail.transferBusinessProfileAndArticleUrls.length > 0">
      <div class="desp-items-group-header">
        <div class="title">Business Profile & Articles of Association of the Proposed Fund Manager</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <company-file-list :fileUrls="detail.transferBusinessProfileAndArticleUrls" :detail="detail" />
        </div>
      </div>
    </div>

    <!-- 基金管理公司的股权架构图 -->
    <div class="desp-items-group" v-if="detail.transferShareholdingStructureUrls && detail.transferShareholdingStructureUrls.length > 0">
      <div class="desp-items-group-header">
        <div class="title">Shareholder Structure of the Proposed Fund Manager</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <company-file-list :fileUrls="detail.transferShareholdingStructureUrls" :detail="detail" />
        </div>
      </div>
    </div>

    <div class="desp-items-group" v-if="detail.transferAnnualFinancialReportUrls && detail.transferAnnualFinancialReportUrls.length > 0">
      <div class="desp-items-group-title"></div>
      <div class="desp-items-group-header">
        <div class="title">Latest Annual Financial Report of the Proposed Fund Manager and its Managed Fund(s) (if applicable)</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <company-file-list :fileUrls="detail.transferAnnualFinancialReportUrls" :detail="detail" />
        </div>
      </div>
    </div>

    <div
      class="desp-items-group"
      v-if="detail.transferRegisteredOfficeAddressCertificateUrls && detail.transferRegisteredOfficeAddressCertificateUrls.length > 0"
    >
      <div class="desp-items-group-title"></div>
      <div class="desp-items-group-header">
        <div class="title">Proof of Registered Office Address of the Proposed Fund Manager – Scanned Copy</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <company-file-list :fileUrls="detail.transferRegisteredOfficeAddressCertificateUrls" :detail="detail" />
        </div>
      </div>
    </div>

    <div class="desp-items-group" v-if="detail.transferSecretaryParticularsUrls && detail.transferSecretaryParticularsUrls.length > 0">
      <div class="desp-items-group-title"></div>
      <div class="desp-items-group-header">
        <div class="title">Particulars of the Current secretary of the fund manager and its managed fund(s)</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <company-file-list :fileUrls="detail.transferSecretaryParticularsUrls" :detail="detail" />
        </div>
      </div>
    </div>

    <div class="desp-items-group" v-if="detail.financeTaxUrls && detail.financeTaxUrls.length > 0">
      <div class="desp-items-group-header">
        <div class="title">
          Particulars of the Finance and Tax In-charge, the Auditors of the Proposed Fund Manager and its Managed Fund(s) Particulars of the Proposed
          Company's Finance and Tax In-charge
        </div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <company-file-list :fileUrls="detail.financeTaxUrls" :detail="detail" />
        </div>
      </div>
    </div>

    <!-- 最终受益人的身份证件/营业执照和地址证明 -->
    <template v-if="detail.questionnaire && detail.questionnaire.ultimateBeneficiaryInfo && detail.questionnaire.ultimateBeneficiaryInfo.length > 0">
      <div class="desp-items-group" v-if="isUltimateBeneficiaryShow">
        <div class="desp-items-group-title"></div>
        <div class="desp-items-group-header">
          <div class="title">
            Ultimate Beneficial Owner(s)' ID/Business Certificate and Proof of Resident/Company Address (lf the requested documents were uploaded elsewhere
            on this page, please upload a text file named "N/A" instead)
          </div>
        </div>
        <div class="desp-item">
          <div class="desp-item-self">
            <div class="shareholder-files">
              <div
                class="shareholder-file-wrapper"
                v-for="(item, idx) in detail.questionnaire.ultimateBeneficiaryInfo"
                :key="`ultimateBeneficiaryInfo${idx}`"
              >
                <template v-if="item.ultimateBeneficiaryBusinessLicenseUrls && item.ultimateBeneficiaryBusinessLicenseUrls.length > 0">
                  <div class="member-info">
                    <span class="name">{{ item.fullName }}</span>
                    <span class="held">{{ memberTypeFormat(item.memberType) }}</span>
                  </div>
                  <div class="file-urls" v-if="item.ultimateBeneficiaryBusinessLicenseUrls">
                    <company-file-list :fileUrls="item.ultimateBeneficiaryBusinessLicenseUrls" :detail="detail" />
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="detail.applicantPosition === 'INDIRECT_SHAREHOLDER' || detail.applicantPosition === 'OTHER'">
      <div
        class="desp-items-group"
        v-if="
          (detail.authorizationUrls && detail.authorizationUrls.length > 0) ||
          (detail.applicantIdentificationUrls && detail.applicantIdentificationUrls.length > 0)
        "
      >
        <div class="desp-items-group-header">
          <div class="title">Authorization of applicant – Scanned copy</div>
        </div>
        <div class="desp-item">
          <div class="desp-item-self" v-if="detail.applicantPosition === 'OTHER' && detail.authorizationUrls && detail.authorizationUrls.length > 0">
            <company-file-list :fileUrls="detail.authorizationUrls" :detail="detail" />
          </div>
          <div
            class="desp-item-self"
            v-if="
              (detail.applicantPosition === 'INDIRECT_SHAREHOLDER' || detail.applicantPosition === 'OTHER') &&
              detail.applicantIdentificationUrls &&
              detail.applicantIdentificationUrls.length > 0
            "
          >
            <company-file-list :fileUrls="detail.applicantIdentificationUrls" :detail="detail" />
          </div>
        </div>
      </div>
    </template>

    <!-- 上传与促销编号相关的支持文件，若有疑问，请联系我们的客户 -->
    <div class="desp-items-group" v-if="detail.promotionCertifiedUrls && detail.promotionCertifiedUrls.length > 0">
      <div class="desp-items-group-header">
        <div class="title">Upload promotion related supporting, contact us if you need any clarification.</div>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <company-file-list :fileUrls="detail.promotionCertifiedUrls" :detail="detail" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CompanyFileList from "../../common/materials/FileList";
export default {
  components: { CompanyFileList },
  props: {
    detail: {
      type: Object,
      default: function () {
        return {
          applymentStatus: "",
          transferBusinessProfileAndArticleUrls: [],
          transferShareholdingStructureUrls: [], // 拟转移公司的股权架构图
          transferAnnualFinancialReportUrls: [], // 拟转移公司的最新的年度财务报告(若适用)
          transferRegisteredOfficeAddressCertificateUrls: [], // 拟转移公司的注册地址证明原件扫描件
          transferSecretaryParticularsUrls: [], // 拟转移公司的现任公司秘书的信息
          applicantIdentificationUrls: [],
          fundInfoList: [], // 基金信息
          fundsShareholdingStructureUrls: [], // 基金的股权架构图
          promotionCertifiedUrls: [], // 上传与促销编号相关的支持文件
        };
      },
    },
  },
  data() {
    return {
      dataListLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["positionHelds", "companyMemberTypes"]),
    ...mapGetters("applyment", ["companyMemberFiles", "companyFundMemberFiles"]),
    passportIcMerge() {
      let identificationFilesArr =
        this.companyMemberFiles && this.companyMemberFiles.identificationFiles ? this.companyMemberFiles.identificationFiles : [];
      let mergeList = [];
      for (let i in identificationFilesArr) {
        mergeList.push({
          positionHeld: identificationFilesArr[i].positionHeld,
          fullName: identificationFilesArr[i].fullName,
          fileUrls: identificationFilesArr[i].fileUrls,
        });
      }
      return mergeList;
    },
    fundIcMerge() {
      let identificationFilesArr =
        this.companyFundMemberFiles && this.companyFundMemberFiles.identificationFiles ? this.companyFundMemberFiles.identificationFiles : [];
      let mergeList = [];
      for (let i in identificationFilesArr) {
        mergeList.push({
          positionHeld: identificationFilesArr[i].positionHeld,
          fullName: identificationFilesArr[i].fullName,
          fileUrls: identificationFilesArr[i].fileUrls,
        });
      }
      return mergeList;
    },
    // 判断“最终受益人的身份证件/营业执照和地址证明”是否需要显示
    isUltimateBeneficiaryShow() {
      let isShow = false;
      const ultimateBeneficiaryInfo = this.detail?.questionnaire?.ultimateBeneficiaryInfo || [];
      for (let i in ultimateBeneficiaryInfo) {
        const atItem = ultimateBeneficiaryInfo[i];
        if (atItem.ultimateBeneficiaryBusinessLicenseUrls && atItem.ultimateBeneficiaryBusinessLicenseUrls.length > 0) {
          // 如果存在ultimateBeneficiaryBusinessLicenseUrls，就显示
          isShow = true;
          break;
        }
      }
      return isShow;
    },
  },
  methods: {
    positionHeldFormat(positionHeld) {
      const one = this.positionHelds.find(i => i.value === positionHeld);
      return one?.title;
    },
    memberTypeFormat(memberType) {
      const one = this.companyMemberTypes.find(i => i.value === memberType);
      return one?.title;
    },
  },
};
</script>

<style lang="scss" scoped>
.company-materials-module {
  .files-wrapper {
    width: 100%;
  }

  .company-files-wrapper {
    .el-col {
      margin-bottom: 20px;
    }
  }

  .shareholder-file-wrapper {
    .member-info {
      color: #353744;
      font-weight: normal;
      // margin-bottom: 15px;

      .name {
        width: fit-content;
        font-size: 16px;
        line-height: 16px;
        margin-right: 10px;
      }
      .held {
        font-size: 13px;
      }
    }
  }

  .desp-items-group-header {
    .title {
      padding: 10px 0;
    }
  }
}
</style>
